import { render, staticRenderFns } from "./declaration_config_preview.vue?vue&type=template&id=1347dcac&"
import script from "./declaration_config_preview.vue?vue&type=script&lang=js&"
export * from "./declaration_config_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports